/* ============================================================
   CaseKaro Homepage UX Fixes v1  (assets/ck-ux-fixes.js)
   Date: 2026-06-11  |  Theme: 142974353526 "Working On It" (DRAFT)

   Tiny progressive-enhancement helper for two CSS-driven fixes:

   [FIX 2] On mobile homepage, hide the redundant sticky HEADER
           search while the hero finder is in view; reveal it once
           the shopper scrolls past the hero. Toggles
           <html class="ck-hide-header-search">.
   [FIX 4] Toggle <html class="ck-cart-empty"> so the cart count
           badge hides when the cart is empty.

   No external deps. If this file fails to load, the CSS fallbacks
   keep everything usable (header search simply stays visible).

   ROLLBACK: delete this file + remove its <script> include in
   layout/theme.liquid (marked "CaseKaro UX fixes").
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- [FIX 2] mobile header-search scroll reveal ---------- */
  function initHeaderSearchReveal() {
    if (!document.body || document.body.className.indexOf('template-index') === -1) return;
    var hero = document.querySelector('.mf-hero');
    if (!hero) return;

    var ticking = false;

    function update() {
      ticking = false;
      // Only act on mobile widths; on desktop never hide the header search.
      if (window.innerWidth > 749) {
        root.classList.remove('ck-hide-header-search');
        return;
      }
      // Hide while the hero is still meaningfully in view.
      var bottom = hero.getBoundingClientRect().bottom;
      if (bottom > 100) {
        root.classList.add('ck-hide-header-search');
      } else {
        root.classList.remove('ck-hide-header-search');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    update(); // set initial state (hidden at top on mobile)
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------- [FIX 4] empty-cart badge state ---------- */
  function getCartCount() {
    var el = document.querySelector('[id$="__header"] #nav-user li.cart #cart-count');
    if (!el) return null;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function updateCartState() {
    var n = getCartCount();
    if (n === null) return;
    root.classList.toggle('ck-cart-empty', n === 0);
  }

  function initCartState() {
    updateCartState();
    var el = document.querySelector('[id$="__header"] #nav-user li.cart #cart-count');
    if (el && window.MutationObserver) {
      new MutationObserver(updateCartState).observe(el, { childList: true, characterData: true, subtree: true });
    }
    // Theme fires cart events on add/remove; re-check on common ones.
    ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(updateCartState, 60); });
    });
  }


  var cartRewardCode = 'CKSAFE10';
  var cartRewardThreshold = 59900;
  var cartRewardSyncing = false;
  var cartRewardSyncQueued = false;

  function getCartRootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getCartEndpoint(path) {
    var rootPath = getCartRootPath();
    if (rootPath.charAt(rootPath.length - 1) !== '/') rootPath += '/';
    return rootPath + path;
  }

  function getDiscountCode(discount) {
    if (!discount) return '';
    if (typeof discount === 'string') return discount.trim();
    return String(discount.code || discount.title || '').trim();
  }

  function getCartDiscountCodes(cart) {
    var codes = [];
    if (Array.isArray(cart && cart.discount_codes)) {
      codes = cart.discount_codes.map(getDiscountCode).filter(Boolean);
    }
    if (!codes.length && Array.isArray(cart && cart.cart_level_discount_applications)) {
      codes = cart.cart_level_discount_applications
        .filter(function (application) {
          return application && application.type === 'discount_code';
        })
        .map(getDiscountCode)
        .filter(Boolean);
    }
    return codes;
  }

  function hasCartDiscountCode(codes, code) {
    var normalized = code.toLowerCase();
    return codes.some(function (item) {
      return item.toLowerCase() === normalized;
    });
  }

  function fetchCartJson() {
    return fetch(getCartEndpoint('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function updateCartDiscount(code) {
    return fetch(getCartEndpoint('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      if (!response.ok) throw new Error('Discount request failed');
      return response.json();
    });
  }

  function notifyCartRefresh() {
    var detail = { source: 'casekaro-rewards' };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
    window.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: detail }));
    if (window.ajaxCart && typeof window.ajaxCart.init === 'function') {
      window.ajaxCart.init();
    }
  }

  function refreshCartDrawer() {
    var cartElement = document.getElementById('cart');
    if (!cartElement) {
      notifyCartRefresh();
      return Promise.resolve();
    }
    var sectionsUrl = getCartEndpoint('cart?sections=side-cart&sections_url=' + encodeURIComponent(window.location.pathname + window.location.search));
    return fetch(sectionsUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart section request failed');
      return response.json();
    }).then(function (payload) {
      var html = payload && payload.sections ? payload.sections['side-cart'] : payload && payload['side-cart'];
      if (html) cartElement.innerHTML = html;
      notifyCartRefresh();
    }).catch(function () {
      notifyCartRefresh();
    });
  }

  function syncCartRewardDiscount() {
    if (cartRewardSyncing) {
      cartRewardSyncQueued = true;
      return;
    }
    cartRewardSyncing = true;
    fetchCartJson().then(function (cart) {
      var subtotal = Number(cart && cart.items_subtotal_price) || 0;
      var discountCodes = getCartDiscountCodes(cart);
      var hasRewardCode = hasCartDiscountCode(discountCodes, cartRewardCode);
      var hasOtherCode = discountCodes.some(function (code) {
        return code.toLowerCase() !== cartRewardCode.toLowerCase();
      });
      var nextCode = null;
      if (subtotal >= cartRewardThreshold && !hasRewardCode && !hasOtherCode) {
        nextCode = cartRewardCode;
      } else if (subtotal < cartRewardThreshold && hasRewardCode && !hasOtherCode) {
        nextCode = '';
      }
      if (nextCode === null) return null;
      return updateCartDiscount(nextCode).then(refreshCartDrawer);
    }).catch(function () {
      return null;
    }).then(function () {
      cartRewardSyncing = false;
      if (cartRewardSyncQueued) {
        cartRewardSyncQueued = false;
        setTimeout(syncCartRewardDiscount, 150);
      }
    });
  }

  function initCartRewardDiscount() {
    ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        setTimeout(syncCartRewardDiscount, 120);
      });
    });
    setTimeout(syncCartRewardDiscount, 300);
  }

  function init() {
    initHeaderSearchReveal();
    initCartState();
    initCartRewardDiscount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
